import { useMutation } from '@tanstack/react-query';
import common from 'constants/common';
import dataService from 'services/dataService';
import { apiPatientPlanOfCareReport } from 'services/dataService/resources';
import { useAppSelector } from 'store';
import { downloadPDF, generateReportName } from 'utils';
import { showResult } from 'infrastructure/hooks/utils';

interface Props {
  patientGuid: string;
  type: 'email' | null;
}

export const usePlanOfCareReport = () => {
  const [startTime, endTime] = useAppSelector<[Date, Date]>(
    (state) => state.patient.dates,
  );

  const { mutate, isLoading } = useMutation({
    mutationFn: async ({ patientGuid, type }: Props) => {
      const timezoneOffset = new Date().getTimezoneOffset();
      const { error, data } = await dataService.getOnly(
        apiPatientPlanOfCareReport(
          patientGuid,
          type,
          startTime,
          endTime,
          timezoneOffset,
        ),
      );

      if (error) {
        showResult(error);
        throw new Error(error);
      }

      if (type === 'email') {
        return showResult(error, common.submitSuccessTypes.sendReport);
      }

      if (!error && data) {
        downloadPDF(
          data,
          generateReportName(
            `planOfCare-report-${patientGuid}`,
            [startTime, endTime],
            'pdf',
          ),
        );
      }

      return data;
    },
  });

  return { getPlanOfCareReport: mutate, planOfCareReportLoading: isLoading };
};
